import React, { memo, useCallback, useEffect, useState } from 'react';
import { useContext } from 'react';
import { SpoolDto } from '../../types/spool-local';
import UserDetails from './UserDetails';
import GeneralDetails from './GeneralDetails';
import CapitalAllocationDetails from './CapitalAllocationDetails';
import appContext from '../../../context/app/appContext';
import useIsMounted from '../../../hooks/useIsMounted';
import { StrategyApyRisks } from '../../../context/app/appTypes';

type Props = {
    spoolDetails: SpoolDto;
    rowCollapsed: boolean;
};

const SpoolsAccordionContent: React.FC<Props> = ({ spoolDetails, rowCollapsed }) => {
    const { getStrategyAllocationDetails } = useContext(appContext);

    const { strategies, riskModelAddress } = spoolDetails;

    const isMounted = useIsMounted();

    const [strategyAllocationDetails, setStrategyAllocationDetails] =
        useState<StrategyApyRisks>();

    const getStrategyDetails = useCallback(async () => {
        try {
            if (!strategies.length) return;

            const details = await getStrategyAllocationDetails(
                strategies,
                riskModelAddress
            );

            if (!details) return;

            isMounted() && setStrategyAllocationDetails(details);
        } catch (error) {
            console.log(error);
        }
    }, [strategies, riskModelAddress, getStrategyAllocationDetails, isMounted]);

    // const getChartData = useCallback(async () => {
    //     try {
    //         const { address } =
    //             (spoolDetails as UserSpoolDto)?.spool ?? (spoolDetails as SpoolDto);
    //         const data = await sdk!.get.getSpoolApyAndTvrHistory(address);

    //         console.log(data);
    //     } catch (error) {
    //         console.log(error);
    //     }
    // }, [sdk, spoolDetails]);

    useEffect(() => {
        if (!strategyAllocationDetails && strategies.length) {
            getStrategyDetails();
            // getChartData();
        }
    }, [strategyAllocationDetails, strategies, spoolDetails, getStrategyDetails]);

    if (!spoolDetails) return null;

    return (
        <>
            <UserDetails spoolDetails={spoolDetails} rowCollapsed={rowCollapsed} />
            <GeneralDetails spoolDetails={spoolDetails} />
            <CapitalAllocationDetails
                strategyAllocationDetails={strategyAllocationDetails}
            />
        </>
    );
};

export default memo(SpoolsAccordionContent);
